import { InjectionToken } from "@angular/core";

export const UIENVSETTINGS = new InjectionToken('ui-environment-settings');
